import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { map, tap, filter, switchMap } from 'rxjs/operators';
import { isNil } from 'lodash-es';

import { DestinationActions } from '../actions';
import { DestinationPersistanceService } from '../destination-persistance.service';
import { Destination } from 'src/objects/destination';


@Injectable()
export class DestinationPersistanceEffects {
  private actions$ = inject(Actions);
  private destinationPersistanceService = inject(DestinationPersistanceService);
  private router = inject(Router);

  init$ = createEffect(() => this.actions$
    .pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.router.events
        .pipe(
          filter(event => {
            if(event instanceof NavigationStart) {
              const regexp = /widget/g;
              const isWidget = regexp.test(event.url);

              return !isWidget;
            }

            return false;
          }),
        ),
      ),
      map(() => this.destinationPersistanceService.get()),
      filter(destinationId => !isNil(destinationId)),
      map(destinationId => DestinationActions.loadDestination({ slugOrId: destinationId })),
    ),
  );

  persistDestination$ = createEffect(() => this.actions$
    .pipe(
      ofType(DestinationActions.setDestination, DestinationActions.loadDestinationSuccess),
      map(({ destination }) => destination),
      filter((d): d is Destination => !!d),
      filter((destination) => destination && destination.destination_type !== 'delivery'),
      tap((destination) => {
        this.destinationPersistanceService.set(destination);
      }),
    ),
    {
      dispatch: false,
    },
  );

  clearDestination$ = createEffect(() => this.actions$
    .pipe(
      ofType(DestinationActions.setDestination),
      filter(({ destination }) => isNil(destination)),
      tap(() => {
        this.destinationPersistanceService.set(null);
      }),
    ),
    {
      dispatch: false,
    }
  );

}


